import _ from 'lodash';
import { config } from '../../../../config';

export const TIME_BETWEEN_BOOKINGS_TEXT = 'Time between bookings (buffer)';

export const NOTICE_BEFORE_BOOKINGS_TEXT = 'Advance notice before bookings';

export const MAX_BOOKINGS_TEXT = 'Max booking per day';

export const STATUS_OPTIONS = [
  { key: 1, text: '0 minutes', value: 0 },
  { key: 2, text: '15 minutes', value: 15 },
  { key: 3, text: '30 minutes', value: 30 },
  { key: 4, text: '60 minutes', value: 60 },
  { key: 5, text: '90 minutes', value: 90 },
];

export const NOTICE_BOOKINGS_OPTIONS = Array.from({ length: 19 }, (x, i) => {
  if (i === 0 || i === 1) {
    return { key: i, text: `${i * 60} minutes`, value: i + 0 };
  }
  return { key: i, text: `${i + 0} hours`, value: i + 0 };
});

export const MAX_BOOKINGS_OPTIONS = Array.from({ length: 15 }, (x, i) => (
  { key: i, text: i + 1, value: i + 1 }
));

export const constructScheduleURL = (project) => {
  const {
    segments = {},
    projectConsentForms,
    recruitParticipantToken,
  } = project;

  const { surveys = [] } = segments[0];

  const hasConsentForm = !_.isEmpty(projectConsentForms);

  return (_.some(surveys, (survey) => survey.surveyType === 'screener') || hasConsentForm)
    ? `${config.REACT_APP_TESTER_PLATFORM_URI}/recruit-participants?token=${recruitParticipantToken && recruitParticipantToken.token}`
    : `${config.REACT_APP_TESTER_PLATFORM_URI}/schedule?segment_id=${segments[0]?.id}`;
};
